import { useTranslation } from 'next-i18next';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { RadioGroup } from '@/components/atoms/RadioSwitch';
import { Span } from '@/components/atoms/Typography/Typography';
import nameSpacesConfig from '@/config/config.nameSpaces.json';
import {
  formFields,
  FormValues,
} from '@/containers/ConfigurePage/components/FormConfig/formData';
import { TransformedAssetCategoryResult } from '@/types/TransformedAssetCategoryResults';
import { ProductSubscriptionByRegionResponse } from '@/utils/fetch/fetchProductSubscriptionByRegion';
import { ChooseMembershipRadioInput } from './ChooseMembershipRadioInput';
import styles from './ChooseMembershipThreeTier.module.scss';
import { useMemberships } from './hooks/useMemberships';

interface Props {
  hasSpecialOffer: boolean;
  product: TransformedAssetCategoryResult;
  subscriptions: ProductSubscriptionByRegionResponse;
}

export const ChooseMembershipThreeTier = ({
  product,
  subscriptions,
}: Props) => {
  const { control } = useFormContext<FormValues>();
  const { t } = useTranslation([
    nameSpacesConfig.pages,
    nameSpacesConfig.product,
  ]);
  const currentFormValues = useWatch<FormValues>({
    defaultValue: {
      durationMonths: '12',
      student: 'no',
      heavyUse: 'no',
    },
  });
  const memberships = useMemberships(subscriptions);

  return (
    <Controller
      control={control}
      name={formFields.durationMonths}
      render={({ field }) => (
        <RadioGroup
          label={t('pages:configure.membership.labelTest')}
          labelChildren={
            <Span version="body1" className={styles.sublabel}>
              {t('pages:configure.membership.sublabel')}
            </Span>
          }
          version="level3"
          className={styles.group}
          onChange={field.onChange}
          value={field.value}
          name={field.name}
        >
          {memberships.map(item => (
            <ChooseMembershipRadioInput
              key={item.durationMonths}
              membership={item}
              currentFormValues={currentFormValues}
              productConfig={product.productConfig}
            />
          ))}
          {/* {currentFormValues.durationMonths === '1' && hasSpecialOffer && (
            <Span className={styles.missingPromoNotification} version="body1">
              <Trans
                components={{
                  bold: <strong />,
                }}
                i18nKey={`pages:configure.membership.specialOffer.${product.productConfig.translationKey}.flexible.label`}
              />
            </Span>
          )} */}
        </RadioGroup>
      )}
    />
  );
};
